"use strict";

/**
 * Web and mobile footer banner
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  // refresh banners after new related videos loaded
  document.addEventListener('flix:additional-related', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled;
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    if (FlixUtils.isMobile()) {
      loadForMobile();
    } else {
      loadForDesktop();
    }
  }
  ;
  function loadForMobile() {
    var adLabel = document.createElement('div');
    adLabel.classList.add('ad-logo');
    adLabel.textContent = 'Ad';

    // On the video page before related
    if (document.querySelector('#bannerBlock_footer')) {
      document.querySelector('#bannerBlock_footer').appendChild(adLabel.cloneNode(true));
      FlixUtils.renderBannerAd(getFooterMobileCode(0), document.querySelector('#bannerBlock_footer'), 'eas6a97888e38', 'ad_error_footer_mobile_0');
    }

    // On the very bottom either for mediabuys or if it's not a video page
    if (document.querySelector('#bannerBlock_footer2')) {
      document.querySelector('#bannerBlock_footer2').appendChild(adLabel.cloneNode(true));
      FlixUtils.renderBannerAd(getFooterMobileCode(1), document.querySelector('#bannerBlock_footer2'), 'eas6a97888e38', 'ad_error_footer_mobile_1');
    }
  }
  ;
  function getFooterMobileCode() {
    var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (Flix.isTna()) {
      return pos ? 5632530 : 4297258;
    } else {
      return pos ? 5632492 : 4290216;
    }
  }
  function loadForDesktop() {
    // Only on video page
    if (!document.querySelector('#desktop_video_footer_ad')) {
      return;
    }
    FlixUtils.renderBannerAd(getZoneId(), document.querySelector('#desktop_video_footer_ad'), 'eas6a97888e38', 'ad_error_footer');
  }
  ;
  function getZoneId() {
    return Flix.isTna() ? '4505222' : '4505302';
  }
})();